import { JobInvitationResponse } from "../../InvitatationSystem/Types/InvitationSystemType";
import { PaginationResponse, PagedStatsResponse } from "../../Shared/Pagination/PaginationResponse";
import { deleteApi, getApi, getApiById, getApiListById, postApi, putApi } from "../../Shared/Services/RestService";
import { JobTemplate, JobTemplateResponse, JobTemplateStats } from "../Types/JobPostTemplateType";


/** Single job template by its own id. Every other read here is a listing. */
export const getJobTemplateById = (id: string) => getApiById<JobTemplate | null>("/job-template", id);

export interface JobTemplateFilters {
  search?: string;
  status?: string;
  recruiterId?: string;
  fromDate?: string;
  toDate?: string;
}

/**
 * Filtered + paginated company job-template listing for the job-management table.
 * `userId` is the current recruiter's user id; the backend resolves the company from it.
 */
export const getCompanyJobsFiltered = (
  userId: string,
  filters: JobTemplateFilters = {},
  page: number = 0,
  size?: number
) => {
  const params: any = {
    page,
  };

  if (filters.search) params.search = filters.search;
  if (filters.status && filters.status !== "ALL") params.status = filters.status;
  if (filters.recruiterId) params.recruiterId = filters.recruiterId;
  if (filters.fromDate) params.fromDate = filters.fromDate;
  if (filters.toDate) params.toDate = filters.toDate;
  if (size !== undefined) params.size = size;

  return getApi<PagedStatsResponse<JobTemplateResponse, JobTemplateStats>>(
    `/job-template/company/${userId}/filtered`,
    params
  );
};


export const getJobTemplateByCompanyRecruiterId = (id: string, page: number =0 ,size?: number ) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApiListById<JobTemplateResponse[]>("/job-template/company", id, params);
};


export const getAllJobInvitationsByUserId = (id: string, status:string, page: number =0 ,size?: number ) => {
  const params: any = {
    page,
    status,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApiListById<PaginationResponse<JobInvitationResponse>>("/invitations/candidates-jobs", id ,params );
};

export const getAllJobs = (page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApi<PaginationResponse<JobTemplateResponse>>("/job-template",params);
};

export const createJobTemplate = (payload: any) => {
  return postApi<JobTemplateResponse>("/job-template", payload);
};

export const updateJobTemplate = (id: string, payload: any) => {
  return putApi<JobTemplateResponse>("/job-template", id, payload);
};

export const deleteJobTemplate = (id: string) => {
  return deleteApi<null>("/job-template", id);
};